<!-- eslint-disable vue/require-prop-type-constructor -->
<script>
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "Timepicker",
    props: {
        id: 0,
        start: "",
        end: "",
        startError: "",
        endError: "",
        options: {
            default() {
                return {
                    startTimeClass: "",
                    endTimeClass: "",
                    startLabel: "",
                    endLabel: "",
                    timeContainerClass: "column",
                    forceShowFirstLabel: false,
                    forceShowSecondLabel: false,
                };
            },
        },
        placeholder: {
            start: "",
            end: "",
        },
        regularLabel: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            firstValue: "",
            secondValue: "",
            firstError: "",
            secondError: "",
        };
    },
    methods: {
        emitUpdate() {
            this.firstValue = this.$refs.startTime.value;
            this.secondValue = this.$refs.endTime.value;
            this.$emit("update", { start: this.$refs.startTime.value, end: this.$refs.endTime.value, id: this.id });
        },
    },
    watch: {
        start() {
            this.$refs.startTime.value = this.start || "";
            this.firstValue = this.start || "";
        },
        end() {
            this.$refs.endTime.value = this.end || "";
            this.secondValue = this.end || "";
        },
    },
    computed: {},
    updated() {
        if (this.start !== "" && this.$refs.startTime.value === "") {
            this.$refs.startTime.value = this.start;
        }

        if (this.end !== "" && this.$refs.endTime.value === "") {
            this.$refs.endTime.value = this.end;
        }
    },
    mounted() {
        const vm = this;

        // We need reference to parent component to properly initialize timepicker for inputs in this component
        const $parent = this.$refs.parentContainer;

        const defaultStartTime = this.start || "06:00";
        const defaultEndTime = this.end || "06:00";

        // TODO: REMOVE JQUERY
        // eslint-disable-next-line no-undef
        $($parent).find(".timepicker.start").timepicker({
            timeFormat: "h:mm p",
            interval: 15,
            minTime: "00",
            maxTime: "11:00pm",
            defaultTime: "",
            startTime: defaultStartTime,
            dynamic: false,
            dropdown: true,
            scrollbar: true,
            // eslint-disable-next-line no-unused-vars
            change(time) {
                vm.startTime = vm.$refs.startTime.value;
                vm.emitUpdate();
            },
        });

        // TODO: REMOVE JQUERY
        // eslint-disable-next-line no-undef
        $($parent).find(".timepicker.end").timepicker({
            timeFormat: "h:mm p",
            interval: 15,
            minTime: "00",
            maxTime: "11:00pm",
            defaultTime: "",
            startTime: defaultEndTime,
            dynamic: false,
            dropdown: true,
            scrollbar: true,
            // eslint-disable-next-line no-unused-vars
            change(time) {
                vm.endTime = vm.$refs.endTime.value;
                vm.emitUpdate();
            },
        });

        if (this.start !== "" && this.$refs.startTime.value === "") {
            this.$refs.startTime.value = this.start;
        }

        if (this.end !== "" && this.$refs.endTime.value === "") {
            this.$refs.endTime.value = this.end;
        }
    },
};
</script>

<template>
    <div ref="parentContainer" data-test="timepicker-range">
        <div class="d-flex flex-row justify-content-between timepicker-range-container">
            <div
                class="d-flex time-container"
                :class="{
                    'flex-column': (
                        options.timeContainer === 'column'
                        || options.timeContainer === ''
                        || options.timeContainer === undefined
                    ),
                    'flex-row': options.timeContainer === 'row'
                }"
                data-test="timepicker-range-start"
            >
                <label
                    class="show"
                    :class="{
                        'mr-2 mb-0': options.timeContainer === 'row',
                        'regular': regularLabel
                    }"
                    v-html="options.startLabel || 'Start time'"
                ></label>
                <div class="d-flex flex-column  position-relative">
                    <input
                        ref="startTime"
                        data-test="timepicker-range-start-input"
                        :placeholder="placeholder?.start || 'Start time'"
                        autocomplete="off"
                        class="timepicker start text pr-4 w-100"
                        :class="options.startTimeClass"
                        :id="id + '1'"
                    />
                    <div class="error" :class="{ 'show': startError}">
                        {{ startError }}
                    </div>
                </div>
            </div>

            <div
                class="d-flex ml-3 time-container second-time-container"
                :class="{
                    'flex-column': (
                        options.timeContainer === 'column'
                        || options.timeContainer === ''
                        || options.timeContainer === undefined
                    ),
                    'flex-row': options.timeContainer === 'row'
                }"
                data-test="timepicker-range-end"
            >
                <label
                    class="show"
                    :class="{
                        'mr-2 mb-0': options.timeContainer === 'row',
                        'regular': regularLabel
                    }"
                    v-html="options.endLabel || 'End time'"
                ></label>
                <div class="d-flex flex-column position-relative">
                    <input
                        ref="endTime"
                        data-test="timepicker-range-end-input"
                        :placeholder="placeholder?.end || 'End time'"
                        autocomplete="off"
                        class="timepicker text end pr-4 w-100"
                        :class="options.endTimeClass"
                        :id="id + '2'"
                    />
                    <div class="error" :class="{'show': endError}">
                        {{ endError }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.timepicker {
    min-width: 334px;
}

label {
    font-size: 0.75rem;
}

label.regular {
    font-weight: 400;
}

.error {
    position: absolute;
    width: 170px;
    font-size: 14px;
    top: 50px;
    left: 0;
}

@media only screen and (max-width: 768px) {
    .timepicker {
        min-width: 100%;
        width: 100%;
    }

    .timepicker-range-container {
        flex-wrap: wrap;
    }

    .second-time-container {
        margin-left: 0 !important;
        margin-top: 10px !important;
    }

    .time-container {
        flex-grow: 1;
    }
}

</style>
